import { h as __h } from "preact";
import html from "~/util/html.js";
/** @import { ComponentChildren } from "preact"; */

import ErrorPage, { ErrorMessage } from "./ErrorPage.js";
import Loader from "./Loader.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Data.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Data.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {ComponentChildren | boolean} [loading]
 * @property {ComponentChildren | Error} [error]
 * @property {ComponentChildren | boolean} [empty]
 * @property {ComponentChildren} [children]
 * @param {Props} props
 */
export default function Data({
  loading,
  error,
  empty,
  children
}) {
  if (error) {
    if (error instanceof Error) {
      return __h(ErrorPage, {
        title: "An error has occurred",
        icon: "nowifi"
      }, __h(ErrorMessage, {
        message: error.message
      }));
    }
    return error;
  }
  if (loading) {
    if (loading === true) return __h("div", {
      "class": css.fallback
    }, __h(Loader, {}));
    return loading;
  }
  if (empty) {
    if (empty === true) return __h("div", {
      "class": css.fallback
    });
    return empty;
  }
  return children;
}